export default __webpack_public_path__ + "static/media/built-by-raid-guild.1218b8b1.svg";